(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3820],{

/***/ 73238:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "At": function() { return /* binding */ BreadcrumbLink; },
/* harmony export */   "aG": function() { return /* binding */ Breadcrumb; },
/* harmony export */   "gN": function() { return /* binding */ BreadcrumbItem; }
/* harmony export */ });
/* unused harmony exports BreadcrumbSeparator, useBreadcrumbStyles */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _chakra_ui_react_children_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(34031);
/* harmony import */ var _chakra_ui_system__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(15818);
/* harmony import */ var _chakra_ui_system__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(54520);
/* harmony import */ var _chakra_ui_react_context__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(28387);
// ../../../react-shim.js


// ../../utilities/shared-utils/src/index.ts
var cx = (...classNames) => classNames.filter(Boolean).join(" ");

// src/breadcrumb.tsx




// src/breadcrumb-context.ts

var [BreadcrumbStylesProvider, useBreadcrumbStyles] = (0,_chakra_ui_react_context__WEBPACK_IMPORTED_MODULE_1__/* .createContext */ .k)({
  name: `BreadcrumbStylesContext`,
  errorMessage: `useBreadcrumbStyles returned is 'undefined'. Seems you forgot to wrap the components in "<Breadcrumb />" `
});

// src/breadcrumb.tsx
var Breadcrumb = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_2__/* .forwardRef */ .Gp)(function Breadcrumb2(props, ref) {
  const styles = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_2__/* .useMultiStyleConfig */ .jC)("Breadcrumb", props);
  const ownProps = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_3__/* .omitThemingProps */ .Lr)(props);
  const {
    children,
    spacing = "0.5rem",
    separator = "/",
    className,
    listProps,
    ...rest
  } = ownProps;
  const validChildren = (0,_chakra_ui_react_children_utils__WEBPACK_IMPORTED_MODULE_4__/* .getValidChildren */ .W)(children);
  const count = validChildren.length;
  const clones = validChildren.map((child, index) => (0,react__WEBPACK_IMPORTED_MODULE_0__.cloneElement)(child, {
    separator,
    spacing,
    isLastChild: count === index + 1
  }));
  const _className = cx("chakra-breadcrumb", className);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_chakra_ui_system__WEBPACK_IMPORTED_MODULE_2__/* .chakra.nav */ .m$.nav, {
    ref,
    "aria-label": "breadcrumb",
    className: _className,
    __css: styles.container,
    ...rest
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(BreadcrumbStylesProvider, {
    value: styles
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_chakra_ui_system__WEBPACK_IMPORTED_MODULE_2__/* .chakra.ol */ .m$.ol, {
    className: "chakra-breadcrumb__list",
    ...listProps,
    __css: {
      display: "flex",
      alignItems: "center",
      ...styles.list
    }
  }, clones)));
});
Breadcrumb.displayName = "Breadcrumb";

// src/breadcrumb-item.tsx



// src/breadcrumb-separator.tsx

var BreadcrumbSeparator = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_2__/* .forwardRef */ .Gp)(function BreadcrumbSeparator2(props, ref) {
  const { spacing, ...rest } = props;
  const styles = useBreadcrumbStyles();
  const separatorStyles = {
    mx: spacing,
    ...styles.separator
  };
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_chakra_ui_system__WEBPACK_IMPORTED_MODULE_2__/* .chakra.span */ .m$.span, {
    ref,
    role: "presentation",
    ...rest,
    __css: separatorStyles
  });
});
BreadcrumbSeparator.displayName = "BreadcrumbSeparator";

// src/breadcrumb-link.tsx

var BreadcrumbLink = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_2__/* .forwardRef */ .Gp)(function BreadcrumbLink2(props, ref) {
  const { isCurrentPage, as, className, href, ...rest } = props;
  const styles = useBreadcrumbStyles();
  const sharedProps = {
    ref,
    as,
    className: cx("chakra-breadcrumb__link", className),
    ...rest
  };
  if (isCurrentPage) {
    return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_chakra_ui_system__WEBPACK_IMPORTED_MODULE_2__/* .chakra.span */ .m$.span, {
      "aria-current": "page",
      __css: styles.link,
      ...sharedProps
    });
  }
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_chakra_ui_system__WEBPACK_IMPORTED_MODULE_2__/* .chakra.a */ .m$.a, {
    __css: styles.link,
    href,
    ...sharedProps
  });
});
BreadcrumbLink.displayName = "BreadcrumbLink";

// src/breadcrumb-item.tsx

var BreadcrumbItem = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_2__/* .forwardRef */ .Gp)(function BreadcrumbItem2(props, ref) {
  const {
    isCurrentPage,
    separator,
    isLastChild,
    spacing,
    children,
    className,
    ...rest
  } = props;
  const validChildren = (0,_chakra_ui_react_children_utils__WEBPACK_IMPORTED_MODULE_4__/* .getValidChildren */ .W)(children);
  const clones = validChildren.map((child) => {
    if (child.type === BreadcrumbLink) {
      return (0,react__WEBPACK_IMPORTED_MODULE_0__.cloneElement)(child, {
        isCurrentPage
      });
    }
    if (child.type === BreadcrumbSeparator) {
      return (0,react__WEBPACK_IMPORTED_MODULE_0__.cloneElement)(child, {
        spacing,
        children: child.props.children || separator
      });
    }
    return child;
  });
  const styles = useBreadcrumbStyles();
  const itemStyles = {
    display: "inline-flex",
    alignItems: "center",
    ...styles.item
  };
  const _className = cx("chakra-breadcrumb__list-item", className);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_chakra_ui_system__WEBPACK_IMPORTED_MODULE_2__/* .chakra.li */ .m$.li, {
    ref,
    className: _className,
    ...rest,
    __css: itemStyles
  }, clones, !isLastChild && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(BreadcrumbSeparator, {
    spacing
  }, separator));
});
BreadcrumbItem.displayName = "BreadcrumbItem";



/***/ }),

/***/ 87200:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/warranty-policy",
      function () {
        return __webpack_require__(85557);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 64070:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ page_header_PageHeader; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/index.esm.js
var index_esm = __webpack_require__(48641);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/breadcrumb/dist/index.esm.js
var dist_index_esm = __webpack_require__(73238);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./components/breadcrumb/AppBreadcrumb.tsx





function AppBreadcrumb(param) {
    let { breadcrumb  } = param;
    // use router
    const { pathname  } = (0,router.useRouter)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Breadcrumb */.aG, {
            separator: ">",
            color: "gray.600",
            className: "app-breadcrumb",
            children: breadcrumb.map((item, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* BreadcrumbItem */.gN, {
                    isCurrentPage: pathname === item.href,
                    children: item.href ? /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: item.href,
                        passHref: true,
                        legacyBehavior: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* BreadcrumbLink */.At, {
                            children: item.label
                        })
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                        noOfLines: 1,
                        children: item.label
                    })
                }, index))
        })
    });
}
/* harmony default export */ var breadcrumb_AppBreadcrumb = (AppBreadcrumb);

;// CONCATENATED MODULE: ./components/page-header/PageHeader.tsx




function PageHeader(param) {
    let { title , breadcrumb , backLink , containerMaxWidth ="850px"  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
                borderBottom: "1px solid",
                borderColor: "primary.400",
                pt: 8,
                pb: 4,
                bgGradient: "linear(to-t, white 55%, #ffd5b1 100%)",
                display: {
                    base: "none",
                    lg: "block"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Container */.W2, {
                    maxWidth: containerMaxWidth,
                    children: [
                        title && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Heading */.X6, {
                            color: "gray.600",
                            fontWeight: "300",
                            fontSize: "lg",
                            children: title
                        }),
                        breadcrumb && breadcrumb.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
                            fontSize: "lg",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(breadcrumb_AppBreadcrumb, {
                                breadcrumb: breadcrumb
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
                py: 2,
                display: {
                    base: "block",
                    lg: "none"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Container */.W2, {
                    children: [
                        title && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Heading */.X6, {
                            color: "gray.600",
                            fontWeight: "300",
                            fontSize: "md",
                            children: title
                        }),
                        breadcrumb && breadcrumb.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(breadcrumb_AppBreadcrumb, {
                            breadcrumb: breadcrumb
                        })
                    ]
                })
            })
        ]
    });
}
/* harmony default export */ var page_header_PageHeader = (PageHeader);


/***/ }),

/***/ 61053:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(48641);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(47741);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);





function PageTitleMobile(param) {
    let { children , backLink  } = param;
    // use router
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__/* .Box */ .xu, {
        bg: "#F36621",
        height: "32px",
        display: {
            lg: "none"
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__/* .Container */ .W2, {
            h: "100%",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__/* .HStack */ .Ug, {
                color: "white",
                h: "100%",
                children: [
                    backLink && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_5__/* .Button */ .zx, {
                        variant: "unstyled",
                        minW: "auto",
                        minHeight: "auto",
                        onClick: ()=>{
                            router.push(backLink, backLink, {
                                locale: router.locale
                            });
                        },
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
                            src: "/image-icon/arrow-prev-white.png",
                            width: 9,
                            height: 12,
                            alt: "next"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__/* .Heading */ .X6, {
                        fontSize: "17px",
                        fontWeight: "400",
                        color: "white",
                        children: children
                    })
                ]
            })
        })
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (PageTitleMobile);


/***/ }),

/***/ 85557:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(48641);
/* harmony import */ var components_page_header_PageHeader__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(64070);
/* harmony import */ var components_page_header_PageTitleMobile__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(61053);
/* harmony import */ var layouts_RootLayout__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(89806);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_4__);






const WarrantyPolicyPage = ()=>{
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_4___default()), {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                    children: "นโยบายรับประกันสินค้า | แลมป์ตั้น"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_5__/* .Box */ .xu, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_page_header_PageHeader__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                        title: "นโยบายรับประกันสินค้า"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_page_header_PageTitleMobile__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                        children: "นโยบายรับประกันสินค้า"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_5__/* .Container */ .W2, {
                        pt: {
                            base: 8,
                            md: 12
                        },
                        pb: {
                            base: 8,
                            md: 20
                        },
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_5__/* .Heading */ .X6, {
                                fontWeight: "500",
                                mb: 6,
                                fontSize: "lg",
                                children: "นโยบายการรับประกันสินค้าสำหรับการสั่งซื้อผ่าน LAMPTAN SHOP ONLINE"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_5__/* .Heading */ .X6, {
                                fontWeight: "500",
                                mb: 6,
                                fontSize: "lg",
                                children: "เงื่อนไขการรับประกัน"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_5__/* .Box */ .xu, {
                                mb: {
                                    base: 8,
                                    md: 10
                                },
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("ul", {
                                    style: {
                                        marginLeft: "20px"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                            style: {
                                                marginBottom: "4px"
                                            },
                                            children: "บริษัทฯ ขอรับประกันคุณภาพผลิตภัณฑ์ที่ลูกค้าได้ซื้อสินค้า รุ่น และรหัสที่ระบุอยู่ในตัวสินค้า และใบรับประกัน เท่านั้น"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                            style: {
                                                marginBottom: "4px"
                                            },
                                            children: "ระยะประกันเริ่มนับตั้งแต่วันที่สินค้าได้มีการซื้อขายและส่งมอบกันระหว่างลูกค้ากับบริษัทฯ โดยมีระยะเวลาประกัน 1 ปี"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                            style: {
                                                marginBottom: "4px"
                                            },
                                            children: "ผู้ซื้อสามารถขอรับบริการตรวจสอบ ซ่อม และเปลี่ยนอะไหล่ (กรณีที่บริษัทฯ พบว่าสินค้าอยู่ในกรณีรับผิดชอบ โดยผู้ซื้อไม่ต้องเสียค่าใช้จ่ายในส่วนค่าแรง และชิ้นส่วนอะไหล่)"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                            style: {
                                                marginBottom: "4px"
                                            },
                                            children: "การรับประกันอยู่ในกรณีที่ สินค้า ไม่สามารถใช้งานได้ เช่น ไฟไม่ติด, หลอดกระพริบ เป็นต้น"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                            style: {
                                                marginBottom: "4px"
                                            },
                                            children: "การรับประกันนี้ไม่รวมถึง ค่าพาหนะ ค่าขนส่งในการให้บริการนอกสถานที่และนอกเขตบริการของบริษัทฯ"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                            style: {
                                                marginBottom: "4px"
                                            },
                                            children: "กรณีสินค้าบกพร่องที่เกิดจากการผลิต ทางบริษัทฯ จะเปลี่ยนสินค้าให้ใหม่หรือทดแทนด้วยสินค้ารุ่นเทียบเท่า"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                            style: {
                                                marginBottom: "4px"
                                            },
                                            children: "ในกรณีที่เกิดความเสียหายขึ้นแต่ทางบริษัทไม่สามารถจัดหาวัสดุหรือชิ้นส่วนในรายการเดียวกันเพื่อใช้ในการซ่อมแซม หรือเปลี่ยนให้ได้ในระยะเวลาการซ่อมแซม บริษัทฯ ขอสงวนสิทธิ์ในการจัดหาวัสดุที่มีคุณสมบัติและมาตรฐานเท่าเทียมกันมาทดแทน"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                            style: {
                                                marginBottom: "4px"
                                            },
                                            children: "ในกรณีที่สินค้าของท่านได้รับการเปลี่ยนชิ้นส่วน หรือได้รับการซ่อมแซมแล้ว ระยะเวลาการรับประกันสินค้าจะยังคงมีผลนับจากวันที่ท่านได้รับสินค้า โดยไม่ได้ขยายเวลานับจากวันที่มีการซ่อมแซมสินค้า"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                            style: {
                                                marginBottom: "4px"
                                            },
                                            children: "ลูกค้าต้องมอบชิ้นส่วนที่ชำรุดบกพร่องของผลิตภัณฑ์ตามรายการที่ได้รับประกันคืนให้แก่เจ้าหน้าที่ของบริษัทฯ"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                            style: {
                                                marginBottom: "4px"
                                            },
                                            children: "บริษัทฯ ขอสงวนสิทธิ์ในการเป็นผู้วินิจฉัย และตัดสินใจว่าสินค้านั้น ๆ อยู่ในเงื่อนไขการรับประกันหรือไม่ คำตัดสินของบริษัทฯ ถือเป็นที่สิ้นสุด"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_5__/* .Heading */ .X6, {
                                fontWeight: "500",
                                mb: 6,
                                fontSize: "lg",
                                children: "เงื่อนไขที่ไม่ได้อยู่ในการรับประกัน"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("ul", {
                                style: {
                                    marginLeft: "20px"
                                },
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                        style: {
                                            marginBottom: "4px"
                                        },
                                        children: "สินค้าชำรุดเพราะถูกใช้ในทางที่ผิดจุดประสงค์ที่ออกแบบไว้ ใช้ผิดวิธี และขาดการบำรุงรักษาที่ถูกต้อง"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                        style: {
                                            marginBottom: "4px"
                                        },
                                        children: "สินค้าถูกดัดแปลง ต่อเติม แก้ไข ซ่อมแซมโดยที่มิใช่ช่างของบริษัทฯ"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                        style: {
                                            marginBottom: "4px"
                                        },
                                        children: "สินค้าชำรุด มีตำหนิ บุบสลาย หรือเกิดรอยขีดข่วน อันเนื่องมาจากสาเหตุภายนอก เช่น การขนส่ง การเคลื่อนย้าย อุบัติเหตุ ความประมาทเลินเล่อ ผลิตภัณฑ์ถูกสารเคมี ภัยธรรมชาติ สัตว์ต่าง ๆ"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                        style: {
                                            marginBottom: "4px"
                                        },
                                        children: "สินค้าสูญหายจากการขนส่ง"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                        style: {
                                            marginBottom: "4px"
                                        },
                                        children: "สินค้าที่ได้รับไม่ตรงตามรายละเอียดสินค้าที่ระบุในเว็บไซต์"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                        style: {
                                            marginBottom: "4px"
                                        },
                                        children: "สินค้าที่ได้รับไม่ตรงตามรายการสั่งซื้อ"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                        style: {
                                            marginBottom: "4px"
                                        },
                                        children: "สินค้าที่ได้รับความเสียหายอันเกิดจากระบบ หรือแรงดันไฟฟ้าไม่ถูกต้องกับผลิตภัณฑ์ที่แนะนำและออกแบบไว้"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                        style: {
                                            marginBottom: "4px"
                                        },
                                        children: "บริษัทฯ ไม่รับประกันสินค้าที่ใช้แล้ว ซึ่งลูกค้าทำการซื้อต่อจากบุคคลอื่น โดยมิได้ซื้อจากบริษัทฯ"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                        style: {
                                            marginBottom: "4px"
                                        },
                                        children: "ใบรับประกันที่ถูกแก้ไข ขูด ขีดฆ่า สูญหาย จะถือว่าเป็นโมฆะ"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                        style: {
                                            marginBottom: "4px"
                                        },
                                        children: "สินค้ากลุ่ม Clearance"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
WarrantyPolicyPage.getLayout = (page)=>{
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(layouts_RootLayout__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        children: page
    });
};
var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = (WarrantyPolicyPage);


/***/ }),

/***/ 9008:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(83121)


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3662,8641,5675,1664,3863,4645,5359,2077,5237,9806,9774,2888,179], function() { return __webpack_exec__(87200); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);